const { AddRecipe } = require("./modal_addRecipe");
const {ModalSplash}=require("./modal_splash");
const {ModalEditor}=require("./modal_editor");
const {ModalSkillsEditor} = require("./modal_editorSkills");
const { ModalLogin } = require("./modal_login");
const { ModalCreateAccount } = require("./modal_createAccount");
module.exports = { AddRecipe, ModalSplash, ModalEditor, ModalSkillsEditor, ModalLogin, ModalCreateAccount };
